import { NotationProps } from '@procore/core-react/dist/_typedoc/Notation/Notation.types.json';
import * as React from 'react';
export default {
  NotationProps,
  React
};